/**
 * Alignment of the &lt;ui5-table-cell&gt; component.
 *
 * @public
 * @experimental
 */
enum TableCellHorizontalAlign {
    /**
     * @public
     */
    Left = "Left",

    /**
     * @public
     */
    Start = "Start",

    /**
     * @public
     */
    Right = "Right",

    /**
     * @public
     */
    End = "End",

    /**
     * @public
     */
    Center = "Center",
}

export default TableCellHorizontalAlign;
